import React from "react";
import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const JunoList = styled.ul`
  display: block;
  color: var(--juno-color-text);
  font-family: var(--juno-font-family-body);
  font-weight: var(--juno-font-weight-light);
  font-size: var(--juno-font-size-body-sm);
  line-height: 1.5;
  margin-bottom: 1em;
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
    margin-bottom: 1.5em;
    line-height: 1.75;
  }
  list-style-type: none;
  padding-left: 0;

  ${(props) =>
    props.number &&
    css`
      padding-left: 16px;
      list-style-type: decimal;

      li {
        padding-left: 8px;
      }
    `};

  ${(props) =>
    props.bullet &&
    css`
      padding-left: 16px;
      list-style-type: disc;

      li {
        padding-left: 8px;
      }
    `};
`;

const JunoListItem = styled.li`
  margin-bottom: 2px;
  ${mediaQueries.md} {
    margin-bottom: 4px;
  }
  ${(props) =>
    props.divider &&
    css`
      font-size: 1em;
      position: relative;
      padding: 4px 0;
      border-bottom: 1px solid var(--juno-color-border);
      background-clip: padding-box;
      ${mediaQueries.md} {
        border-width: 2px;
        padding-bottom: 8px;
      }
    `};
`;

function List(props) {
  return (
    <JunoList as={props.number ? "ol" : "ul"} {...props}>
      {props.children}
    </JunoList>
  );
}

export function ListItem(props) {
  return <JunoListItem {...props}>{props.children}</JunoListItem>;
}

export default List;
